"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.triggerFeedback = exports.getEpoqTestGroup = exports.setEpoqCartData = exports.epoqForeignInit = exports.waitForEpoqInit = exports.epoqRequestTimeout = exports.EPOQ_SEARCH_FALLBACK_TIMEOUT = exports.EPOQ_SEARCH_FALLBACK_URL = exports.EPOQ_SEARCH_URL = void 0;
const ocm_object_1 = require("./ocm-object");
exports.EPOQ_SEARCH_URL = "https://search.epoq.de/inbound-servletapi/getSearchResult";
exports.EPOQ_SEARCH_FALLBACK_URL = "https://searchstandby.epoq.de/inbound-servletapi/getSearchResult";
exports.EPOQ_SEARCH_FALLBACK_TIMEOUT = 300000;
const SEARCH_TIMEOUT = 4000; // TUB-16829
function epoqRequestTimeout() {
    return new Promise((_, reject) => {
        window.setTimeout(() => {
            reject(new Error("Epoq Search request timed-out"));
        }, SEARCH_TIMEOUT);
    });
}
exports.epoqRequestTimeout = epoqRequestTimeout;
const TIMEOUT_DURATION = 30000;
const POLLING_FREQUENCY = 300;
async function waitForEpoqInit(_timeoutDuration = TIMEOUT_DURATION) {
    let isTimeout = false;
    const interval = window.setInterval(() => {
        isTimeout = true;
    }, _timeoutDuration);
    return new Promise(function check(resolve, reject) {
        if (window.EpoqNS) {
            window.clearInterval(interval);
            return resolve();
        }
        if (isTimeout) {
            window.clearInterval(interval);
            return reject();
        }
        window.setTimeout(() => check(resolve, reject), POLLING_FREQUENCY);
    });
}
exports.waitForEpoqInit = waitForEpoqInit;
const epoqForeignInit = async (appName) => {
    var _a;
    /**
     * Info von Epoq (15.1.2021)
     * „Wichtig ist, dass die Funktion nur einmal pro State Change aufgerufen wird und zwar dann, wenn alle components/Html-Strukturen des neuen States gerendert sind.
     * Da zu diesem Zeitpunkt normalerweise das Routing/pushState erfolgt sein sollte, ist das Funktionsargument ggf. obsolet. Trotzdem wäre es gut, wenn es zum Abgleich gesetzt werden würde.
     * Generell bleibt es bei einem Funktionsparameter (object), der dann bei Bedarf für spätere Szenarios erweitert werden kann.
     * Aktuell wäre also nur der key `stateUrl` zu setzen. Dieser sollte die Url des neu aufgerufenen States enthalten.“
     */
    try {
        await waitForEpoqInit();
        console.log("%c%s", "color:#fff;background-color:#35495e;", `${appName}: EpoqNS.epoqForeignInit`);
        const stateUrl = window.location.href;
        (_a = window.EpoqNS) === null || _a === void 0 ? void 0 : _a.epoqForeignInit({ stateUrl });
    }
    catch (error) {
        console.error("error loading epoq");
    }
};
exports.epoqForeignInit = epoqForeignInit;
async function setEpoqCartData() {
    var _a, _b, _c, _d, _e, _f, _g;
    const recommendation = window.recommendationData.Recommendation;
    const isAuthenticated = recommendation.customerData.authlevel > 0;
    const pageType = (_a = recommendation.pageData) === null || _a === void 0 ? void 0 : _a.pageType;
    const pageUid = (_b = recommendation.pageData) === null || _b === void 0 ? void 0 : _b.pageUid;
    if (ocm_object_1.isClassicSite || !isAuthenticated || !pageType || !pageUid)
        return;
    if (pageType !== "LandingPage" && !["notFound", "multiStepCheckoutSummaryPage"].includes(pageUid)) {
        try {
            await waitForEpoqInit();
            const products = (_e = (pageType === "ThankYouPage"
                ? (_c = recommendation.orderData) === null || _c === void 0 ? void 0 : _c.products
                : (_d = recommendation.customerData.cart) === null || _d === void 0 ? void 0 : _d.products)) !== null && _e !== void 0 ? _e : [];
            products.forEach((item, i) => {
                window.epoq_productIds[i] = String(item.style);
                window.epoq_unitPrices[i] = parseFloat(item.price);
                window.epoq_quantities[i] = Number(item.quantity);
            });
            pageType === "ThankYouPage" ? (_f = window.epoq_processCart) === null || _f === void 0 ? void 0 : _f.call(window) : (_g = window.epoq_updateCart) === null || _g === void 0 ? void 0 : _g.call(window);
        }
        catch (error) {
            console.error("error loading epoq / updateCart/processCart\n", error);
        }
    }
}
exports.setEpoqCartData = setEpoqCartData;
const EPOQ_PLP_TEST_GROUP_STORE = "plpTestGroup";
function getEpoqTestGroup() {
    var _a, _b;
    // z.B. "abtest_136_B"
    const epoqTestGroup = (_b = (_a = window.flowConfig) === null || _a === void 0 ? void 0 : _a.partName) !== null && _b !== void 0 ? _b : sessionStorage.getItem(EPOQ_PLP_TEST_GROUP_STORE);
    // we need to write the test group to session storage because `flowConfig` is not available in the checkout
    if (epoqTestGroup !== null)
        sessionStorage.setItem(EPOQ_PLP_TEST_GROUP_STORE, epoqTestGroup);
    return epoqTestGroup;
}
exports.getEpoqTestGroup = getEpoqTestGroup;
const triggerFeedback = (feedbackUrl) => {
    if (feedbackUrl === null || feedbackUrl === void 0 ? void 0 : feedbackUrl.length) {
        // 🔺 `target` causes epoq to redirect to the URL of `target`, which is unnecessary and leads to errors
        const url = new URL(feedbackUrl);
        url.searchParams.delete("target");
        feedbackUrl = url.toString();
        try {
            fetch(feedbackUrl, { mode: "no-cors", method: "HEAD" });
        }
        catch (error) {
            console.error(error);
        }
    }
};
exports.triggerFeedback = triggerFeedback;
